import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTranslation } from 'react-i18next';
import { createDeck } from '../services/deckService';
import DeckForm from '../components/DeckForm';
import { Container, Box, Typography } from '@mui/material';

const CreateDeckPage: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();

  if (!user) {
    navigate('/');
    return null;
  }

  const handleCreateDeck = async (data: {
    title: string;
    description: string;
    sideNames: string[];
    tags: string[];
    isPublic: boolean;
  }) => {
    try {
      const deck = await createDeck({
        ...data,
        userId: user.uid,
      });
      if (deck && deck.id) {
        navigate(`/decks/${deck.id}`);
      } else {
        console.error('Failed to create deck: No ID returned');
      }
    } catch (error) {
      console.error('Error creating deck:', error);
    }
  };

  return (
    <Container maxWidth="lg">
      <Box sx={{ my: 4 }}>
        <Typography variant="h4" gutterBottom>
          {t('decks.createDeck')}
        </Typography>
        <DeckForm
          open={true}
          onClose={() => navigate('/decks')}
          onSave={handleCreateDeck}
        />
      </Box>
    </Container>
  );
};

export default CreateDeckPage; 